import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { authService } from '@/services/auths/auth-service';
import type { AuthentificatedUser } from '@/types/core/authentificated-user';

export function useUser(): {
  user: AuthentificatedUser | null;
} {
  const { user } = useAuth();
  const fullUser = useMemo(
    () => (user ? authService.formatSsoUser(user) : null),
    [user],
  );

  return { user: fullUser };
}
